// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/activestorage").start()
require("channels")
require("jquery")
require("jquery-ui")
require("moment")

import {} from 'jquery-ujs'
import "bootstrap";
import "../stylesheets/application";
import "@fortawesome/fontawesome-free/js/all";
import "./custom";
import "bootstrap-select";
import "./bootstrap-confirmation";
import "./bootstrap-suggest";
import "cocoon";
import "./fullcalendar";
